import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { fadeUp, viewport } from "@/components/anim";

const FAQS = [
  {
    q: "How exactly does payment work?",
    a: "Send exactly 2 SOL to the VIP wallet shown in the join modal (scan the QR with Phantom or Solflare, or copy the address). Then paste your transaction signature — we verify it directly against the Solana blockchain and unlock the group instantly.",
  },
  {
    q: "When do I get the Telegram link?",
    a: "The moment your 2 SOL transaction is confirmed on-chain and verified, the private Telegram invite link appears on screen. No waiting, no manual approval.",
  },
  {
    q: "Where do I find my transaction signature?",
    a: "After sending SOL, your wallet (Phantom/Solflare) shows the transaction. Open it, copy the signature (a long string of letters and numbers) or grab it from Solscan, and paste it into the input box.",
  },
  {
    q: "How do the airdrops and bots reach me?",
    a: "Once inside, you'll drop your wallet address for pre-public airdrops and get a step-by-step setup for the custom sniper bots. Whale-tracking alerts are pushed straight into the group feed.",
  },
  {
    q: "Is this a one-time payment?",
    a: "Yes. 2 SOL buys lifetime access — no renewals, no monthly fees, no upsells.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 bg-[#0A0D14] border-t border-[#14f19514]"
    >
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="mb-12"
        >
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#14F195]">
            / Questions
          </span>
          <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            No fine print.
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid="faq-accordion-item"
              className="border-b border-[#ffffff12]"
            >
              <AccordionTrigger className="text-left font-display font-semibold text-white hover:text-[#14F195] hover:no-underline py-5 text-base sm:text-lg">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#94A3B8] leading-relaxed text-sm sm:text-base pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
